import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ApiExplorer from './components/ApiExplorer';
import HomePage from './pages/HomePage';
import TableViewerPage from './pages/TableViewerPage';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/explorer" element={<ApiExplorer />} />
            <Route path="/table-viewer" element={<TableViewerPage />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;

